export function getBaseUrlFromConfig(configs) {
  const protocol = configs.protocol || 'https';
  const port = configs.port ? ':' + configs.port : '';
  const basePath = configs.basePath || '';
  return protocol + '://' + configs.host + port + basePath;
}

export function getBaseUrlWithoutProtocolFromConfig(configs) {
  const port = configs.port ? ':' + configs.port : '';
  const basePath = configs.basePath || '';
  return configs.host + port + basePath;
}
